jQuery(document).ready(function($) { 

 /*  ***************************
   VAR
  ******************************** */
  var LARGEUR_MAX_MOBILE = 1023;
  var header = $('#masthead');
  var l_window = parseInt($(window).width());


  /*  ***************************
   ONLY DESKTOP
  ******************************** */

  if(l_window > 1023 && $('.Inclus-Container').length){
    var h_inclus_left = $('.Inclus-ContentLeft').height();
    var taille_bloc = $('.Modulable').height() + $('.Inclus-Right').height();
    if(h_inclus_left > taille_bloc){
      $('.Modulable').css('padding-bottom', parseInt(h_inclus_left - taille_bloc - 20));
    }
  }

 

   /*  ***************************
    SUBMIT FORM (MONEY CHANGE)
  ******************************** */
    $('#currency').on('change', function() {

        $( "#form_change_money" ).submit();
      
    });


      //  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();
   
  
  /*  ***************************
   PAGE VOYAGE / MOBILE / OUVERTURE / FERMETURE DES FILTRES 
  ******************************** */
  var $filter_to_open = $('#form_filter');

  $(".js-open-filter").click(function(evt) {
    if($(this).attr('aria-expanded') == "false"){
      $(this).attr('aria-expanded', "true"); 
      $filter_to_open.slideDown(500);
       $(this).text($(this).attr('data-txt-close'));
    }else{
        $(this).attr('aria-expanded', "false");
        $filter_to_open.slideUp(500);
       $(this).text($(this).attr('data-txt-open'));
    }
    
    });

  var header_sub_destination = $('.header-sub-destination');
  //this.$subsContainer.on("mouseleave", $.proxy(this.onMouseLeaveNav, this)
  /*  ***************************
   GESTION MENU
  ******************************** */

    if(l_window > 1023){
    $( "#menu-item-21,#menu-item-765" ).mouseenter(function() {
      active_sub_menu_dest();
    });

     $( "#menu-item-21,#menu-item-765" ).mouseleave(function(e) {
      if($(e.relatedTarget).parents('.header-subs').length) {
        
      }else{
        disable_sub_menu_dest();
      }
     })

    $( ".header-sub-destination" ).mouseleave(function(e) {
      if(header_sub_destination.hasClass('active')) disable_sub_menu_dest();
      
    });

     $( "#header-sub-destination" ).mouseenter(function() {
      active_sub_menu_dest();
    });
  }


  function active_sub_menu_dest(){
    header_sub_destination.addClass('active');
    header.addClass('bg_for_hover');
  }
  function disable_sub_menu_dest(){
    header_sub_destination.removeClass('active');
    header.removeClass('bg_for_hover');
  }

   $("#menu-item-21 a, #menu-item-765 a").click(function(evt) {
        active_sub_menu_dest();
        evt.preventDefault();
    });

  $(".header-burger-back").click(function(evt) {
       disable_sub_menu_dest();
        evt.preventDefault();
    });
  
  





  /*  ***************************
    LIEN VERS ENFANT 
  ******************************** */

    $(".LinkToChild-js").click(function() {
        document.location = $(this).find("a").attr("href");
    });


 	 $(window).scroll(function () {
      action_on_scroll();
    });

    function action_on_scroll(){

      var l_window = parseInt($(window).width());
      h_header = $("#masthead").height();

      if (l_window > LARGEUR_MAX_MOBILE){
         if ($(window).scrollTop() > h_header - 30){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
          }else{
                header.removeClass("Masthead--sticky");
              $("body").removeClass('header--sticky');
          }
      }else{

        if ($(window).scrollTop() > 0){
          header.addClass("fixed_scrol_mobile");
          $("body").addClass('header--sticky');
              }else{
                header.removeClass("fixed_scrol_mobile");
                $("body").removeClass('header--sticky');
              }
      }
   }



// /*  ***************************
//  	SLIDE BLOCK !!
// ******************************** */


 /* Gallerie SLIDER POST RELATED */
// $('.VoyageSelection-Container').slick({
//       //setting-name: setting-value
//       dots: false,
//       arrows:true,
//       speed:1400,
//       infinite:true,
//       slidesToShow: 3,
//       slidesToScroll: 3,
//       responsive: [
//         {
//           breakpoint: 768,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 2,
//             arrows:true,
//             dots: true
//           }
//         },
//         {
//           breakpoint: 500,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             arrows:true,
//             dots: false
//           }
//         }
//      ]
// })

$slick_slider = $('.VoyageSelection-Container');
  settings_slider = {
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows:false,
  dots: true,
  responsive: [
    {
      breakpoint: 490,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         arrows:false,
        dots: true
      }
    }
  ]
    // more settings
  }

  slick_on_mobile( $slick_slider, settings_slider);

// slick on mobile
  function slick_on_mobile(slider, settings){
    $(window).on('load resize', function() {
      if ($(window).width() > 1024) {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
        return
      }
      if (!slider.hasClass('slick-initialized')) {
        return slider.slick(settings);
      }
    });
  };


// }).on('setPosition', function (event, slick) {
//     slick.$slides.css('height', slick.$slideTrack.height() + 'px');
// });



// /*  ***************************
//  PARTENAIRES SLIDER
// ******************************** */

// $('.PartersFooter-Slide-js').slick({
//       //setting-name: setting-value
//       dots: true,
//       arrows:false,
//       speed:1400,
//       infinite:true,
//       slidesToShow: 4,
//       slidesToScroll: 4,
//       autoplay:true,
//       responsive: [
//       {
//           breakpoint: 1154,
//           settings: {
//             slidesToShow: 3,
//             slidesToScroll: 3,
//              arrows:false,
//             dots: true
//           }
//         },
//         {
//           breakpoint: 768,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 2,
//              arrows:false,
//             dots: true
//           }
//         }
//      ]
// });

    $('.to_nicedropdown-js').niceSelect();

 // /*  ***************************
//  GALERIE TOP ACCUEIL
// ******************************** */

    $('.GalleryTopHome').slick({
        //setting-name: setting-value
        dots: true,
        infinite:true,
        arrows:false,
        draggable:false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed:1400,
        fade: true,
        pauseOnHover:false,
        pauseOnFocus:false
   });

 // /*  ***************************
//  GALERIE SIMPLE DANS LES PAGES (avec pagination)
// ******************************** */


     $('.GallerySimple').slick({
        //setting-name: setting-value
        dots: true,
        infinite:false,
        arrows:false,
        draggable:false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed:1400,
        fade: true,
        pauseOnHover:false,
        pauseOnFocus:false
   });


 // /*  ***************************
//  GALERIE TOP DANS LES PAGES DE VOYAGES
// ******************************** */


     $('.SingleVoyage-TopGallery').slick({
        //setting-name: setting-value
        dots: true,
        infinite:false,
        arrows:false,
        draggable:false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed:1400,
        fade: true,
        pauseOnHover:false,
        pauseOnFocus:false
   });

     $('.SliderTabs').slick({
        //setting-name: setting-value
        dots: true,
        infinite:false,
        arrows:false,
        draggable:false,
        autoplay: false,
        //autoplaySpeed: 5000,
        speed:1400,
       // fade: true,
        pauseOnHover:false,
        pauseOnFocus:false
   });


     

    
    

 // /*  ***************************
//  -----> TABS
// ******************************** */

    $(".js-Tabs-Inner-Content").hide();
    $(".js-Tabs-Inner-Content:first").show();

  /* if in tab mode */
    $(".Tabs-Liste li").click(function() {
    
      $(".js-Tabs-Inner-Content").hide();
      var activeTab = $(this).attr("rel"); 
     $("#"+activeTab).find('.SliderTabs--js').css('opacity', 0);
      $("#"+activeTab).fadeIn(300,function(){
        
         $("#"+activeTab).find('.SliderTabs--js').slick('refresh',$("#"+activeTab).find('.SliderTabs--js').css('opacity', 1));
         $("#"+activeTab).find('.GallerySimple').slick('refresh');
         
      });    
    
      $(".Tabs-Liste li").removeClass("active");
      $(this).addClass("active");

    $(".js-Tabs-Inner-Title").removeClass("d_active");
    $(".js-Tabs-Inner-Title[rel^='"+activeTab+"']").addClass("d_active");
      
     

    
    });
  /* if in drawer mode */
  $(".js-Tabs-Inner-Title").click(function() {
      
      if($(this).next().css('display') == 'none'){
          $(".js-Tabs-Inner-Content").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).fadeIn(300, function(){
             $("#"+d_activeTab).find('.SliderTabs--js').slick('refresh',$("#"+d_activeTab).find('.SliderTabs--js').css('opacity', 1));
             $("#"+d_activeTab).find('.GallerySimple').slick('refresh');

          });
        
        $(".js-Tabs-Inner-Title").removeClass("d_active");
          $(this).addClass("d_active");
        
        $(".Tabs-Liste li").removeClass("active");
        $(".Tabs-Liste li[rel^='"+d_activeTab+"']").addClass("active");
    }else{
      $(this).next().slideUp(400);
      $(".js-Tabs-Inner-Title, .Tabs-Liste li").removeClass("d_active");
    }
   });

  
  /* Extra class "tab_last" 
     to add border to right side
     of last tab */
  $('.Tabs-Liste li').last().addClass("tab_last");
  $('.Tabs-Liste li').first().addClass("active");

  // GET HASH ? 
   // SI #tab1, #tab2, #tab3.. alors on clique sur le li pour activer le bon js-Tabs-Inner-Content //
   if(window.location.hash) {
    var $hash_location = window.location.hash;
    if($hash_location == '#tab1' || $hash_location == '#tab2' || $hash_location == '#tab3' || $hash_location == '#tab4')
    {
      $hash_location = $hash_location.substring(1);
      $( ".Tabs-Liste li[rel='"+$hash_location+"']").trigger( "click" );
    }
  } 
  // FIN TABS 


 // /*  ***************************
//  DESTINATIONS SLIDER 
// ******************************** */

   // /*  ***************************
    //  SUR MOBILE, UNE LISTE DEROULANTE POUR ACTIVTE TEL OU TEL DESTINATION
    // ******************************** */
      var ContainerItem = $('.Destination-ContentTxt');


      $('#mobile_choose_dest_js').on('change', function() {

          var to_display = this.value;

           if(ContainerItem.find('.ActiveDesc').length != 0){
            var anchor = $(".Destination-Header");
             $("html, body").animate( { scrollTop: anchor.offset().top-100}, 500);

              $('.ActiveDesc').fadeOut(500, function(){
                 $("#"+to_display).fadeIn(700);
                 $('.ActiveDesc').removeClass('ActiveDesc');
                 $("#"+to_display).addClass('ActiveDesc');
              })
            }else{
              $("#"+to_display).fadeIn(700);
              $("#"+to_display).addClass('ActiveDesc');
            }
      });

    $('.GlobeSlider').slick({
        //setting-name: setting-value
        dots: false,
        infinite:true,
        arrows:true,
        draggable:true,
        //autoplay: true,
        //autoplaySpeed: 5000,
        speed:600,
        fade: true,
        pauseOnHover:false,
        pauseOnFocus:false
   });

    
   
    $( ".Point-js" ).click(function() {
      var to_display = $(this).attr('data-dest');
      $('.Point-js').removeClass('active');
      $(this).addClass('active');

      if(ContainerItem.find('.ActiveDesc').length != 0){
        $('.ActiveDesc').fadeOut(500, function(){
           $("#"+to_display).fadeIn(700);
           $('.ActiveDesc').removeClass('ActiveDesc');
           $("#"+to_display).addClass('ActiveDesc');
        })
      }else{
        $("#"+to_display).fadeIn(700);
        $("#"+to_display).addClass('ActiveDesc');
      }
  });



  // Formulaire de contact ///
   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form input[type='tel'], .wpcf7-form select" ).click(function() {
      $( this ).parent().addClass('focus');
  });

    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form input[type='tel'],.wpcf7-form textarea, .wpcf7-form select" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });
 
   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='tel'],.wpcf7-form input[type='text'],.wpcf7-form textarea, .wpcf7-form select" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });


  /* *****************  */
    /* ISOTOPE OFFRES D'EMPLOIS
  /* *****************  */

   var $grid = $('.grid').isotope({
      // main isotope options
      itemSelector: '.grid-item',
      percentPosition: true,

      // options for masonry layout mode
      masonry: {
        columnWidth: '.grid-sizer',
        gutter: '.gutter-sizer',
      }
    });

$grid.imagesLoaded().progress( function() {
  $grid.isotope('layout');
});
    

    ////////////////
   /// ACORDEON //
   // .not( "#content_s_1" )
   $('.accordion-section-content').hide();
    //$('#content_s_1').parent().find('h2 a').addClass('active');

   //$('.accordion-section-content').hide();
    // ACCORDEON SECTION 
    function close_accordion_section() {
        $('.accordeon-page .accordion-section-title').removeClass('active');
        $('.accordeon-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('href');
      
         $('.accordeon-page .FAQ-Item.active .FAQ-Item-Content').not(currentAttrValue).slideUp(300);
         $('.accordeon-page .FAQ-Item.active .FAQ-Item-Content').not(currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $('.accordeon-page ' + currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            // Open up the hidden content panel
            $('.accordeon-page ' + currentAttrValue).slideDown(300).addClass('open'); 
        }
 
        e.preventDefault();
    });
    // FIN ACCORDEON //
    ////////////////////



}); // fin ready menu